import React, { useState, useEffect } from 'react';
//import { BrowserRouter , Route, Switch } from 'react-router-dom';
import { BrowserRouter , Route } from 'react-router-dom';
//import { Redirect } from "react-router-dom";
import { Navigate, Routes } from 'react-router-dom';
import './App.css';
import Nav from './componentes/Nav';
import Main from './componentes/Main';
import ContenedorVistas from './componentes/ContenedorVistas';
import Home from './Vistas/Home';
import Login from './Vistas/Login';
import {Tramites} from './componentes/Tramites';
import Loading from './componentes/Loading';
import Error from './componentes/Error';
import {AlumnoProvider, useAlumno } from './Context/alumnoContext'; // importo proveedor de contexto y luego envuelvo a la aplicación en el mismo
import Axios from 'axios';
import {setToken, deleteToken, getToken, initAxiosInterceptors} from './Helpers/auth-helpers'
import {fechaActual,compararFechas} from './Helpers/fechas';
import Swal from 'sweetalert2';
import {ErrorBoundary} from 'react-error-boundary'
import {MenuAppBar} from './componentes/MUI/MenuAppBar'
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import {CustomSnackBar} from './componentes/MUI/CustomSnackBar';
import {Temporal} from './componentes/Temporal';
import Doctrina from './componentes/Doctrina';
import Estatutos from './componentes/Estatutos';
import { ThemeProvider } from "@material-tailwind/react";
import { MenuSidebar } from './componentes/sidebar';
import Alert from '@mui/material/Alert';
import { MenuDrawer } from './componentes/drawer';
import Footer from './componentes/Footer';
import {
  Spinner, 
} from "@material-tailwind/react";

// variables para monitoreo de actividad
let tiempo_en_segundos_inactividad = 7200;
let contador; 
let id_intervalo_monitoreo;
let id_intervalo_contador;
let id_tiempo_reinicio;

const client_graphql = new ApolloClient({
  uri: process.env.REACT_APP_API_GRAPHQL,
  cache: new InMemoryCache()
});

initAxiosInterceptors(); // esto se llama apenas se ejecute el archivo principal antes de 
                         // cargar la función app para que se active el proceso de analizar
                          // cada request de entrada para ver si hay un error de autorización
                          // y cada request de salida para añadirle el token si es que existe
                          // se añade al header para que el servidor lo reciba en el request y
                          // lo autorice para las rutas protegidas
function App() {
  const [usuario,setUsuario] = useState(null) // es estado inicial del usuario es null o sea no hay usuario
  const [cargandoUsuario,setCargandoUsuario]=useState(true);
  const [error,setError] = useState(null);
  const [hora,setHora] = useState(null);
  const [reinicioLogin,setReinicioLogin]=useState(0)
  const [verCredencial,setVerCredencial]=useState(false)
  const [parametros,setParametros] = useState({})
  const {alumno,
        setAlumno,
        mostrarBusquedaAlumnos,
        reinicializarAlumno,
        mensaje,
        reinicializarMensaje,
        cuatrimestreActivo, cambiarCuatrimestreActivo,
        setearUsuario,
        setearParametros,
        obtenerObrero,
        esCelular,
        infoObrero,
        isIOSWebView,
        contadorOperacionesGlobales} = useAlumno();


  useEffect(()=>{

    async function cargarUsuario(){

        if(!getToken()){
            setCargandoUsuario(false); // si no hay token debe re loguearse
            return;
        }else{
            try{
                const { data } = await Axios.get('/api/usuarios/whoami');
                setUsuario(data.usuario);
                obtenerObrero(data.usuario.id_obrero);
                setearUsuario(data.usuario); // para exponerlo en el context
                setCargandoUsuario(false);

            }catch(error){
                console.log(error)
            }
        }
    }

    
    cargarUsuario()
    confirmarTiempoInactividadAceptado()
  },[]); // el segundo parametro [] se pasa para que se ejecute 1 sola vez 

  async function cargarParametros(){
    try{
      const { data } = await Axios.get('/api/tablasgenerales/parametros');

      setParametros(data)
      setearParametros(data)

  }catch(error){
      console.log(error)
    }
  }

  useEffect(()=>{

   if (usuario){
      cargarParametros()
      obtenerObrero(usuario.id_obrero) // agregado el 24/01/2026 y comentado en login
      activarMonitoreoActividad(setReinicioLogin) // cada vez que se loguea el usuario o se refresca la vista se
                                                  // se activa el monitoreo de la actividad para detectar 
                                                  // tiempos de inactividad y si fuese necesario pedir al usuario 
                                                  // que confirme que sigue conectado
    }
 
  },[usuario,contadorOperacionesGlobales])

  function logout(){
      setUsuario(null);
      reinicializarAlumno()
      deleteToken();
  }

  function reiniciarLogin(){
    window.location.reload()
  }

  function activarMonitoreoActividad(setReinicioLogin){
    // cada vez que se inicia el monitoreo de actividad se limpian los flags para 
    // asegurarnos que se reinicie el proceso
    sessionStorage.removeItem('haction')
    sessionStorage.removeItem('checking')

    // se repite el control de actividad cada 5 segundos
    // pasamos la función setReinicioLogin por si es necesario forzar el renderizado de la vista
    // cambiando el estado en el caso de que se haya detectado un tiempo X de inactividad
    id_intervalo_monitoreo = setInterval(() => {
          verificarTiempo(reiniciarLogin)        
    }, 5000);
  }

  function mostrarError(error){
      setError(error)
  };

  function esconderError(){
      setError(null)
  }

  function esconderMensaje(){
    setError(null)
}

function ocultarCredencial(){
    setVerCredencial(false)
}

function mostrarCredencial(){
  setVerCredencial(true)
}


async function login(nro_documento, cod_seguridad, captchaToken) {
  try {
    setCargandoUsuario(true);
    setError(null);

    const { data } = await Axios.post('/api/usuarios/login/secure', {
      nro_documento,
      cod_seguridad,
      captchaToken
    });

    //await obtenerObrero(data.usuario.id_obrero);
    
    setUsuario(data.usuario);
    setearUsuario(data.usuario);
    setToken(data.token);
    setCargandoUsuario(false);

  } catch (err) {
    setCargandoUsuario(false);
   
      let mensaje = 'No es posible conectar con el servidor.';

    if (err.response?.data) {
      const { code, message } = err.response.data;

      switch (code) {
        case 'INVALID_CREDENTIALS':
          mensaje = 'Los datos ingresados no son correctos. Por favor verifique su DNI y código de seguridad.';
          break;
        case 'RATE_LIMIT_EXCEEDED':
          mensaje = 'Demasiados intentos. Por favor, espere unos minutos y vuelva a intentarlo.';
          break;
        case 'CAPTCHA_INVALIDO':
          mensaje = 'La validación de seguridad falló. Por favor intente nuevamente.';
          break;
        default:
          mensaje = message || 'Error al intentar ingresar.';
      }
    } 

     setError(mensaje);
     throw new Error(mensaje) // para que sea capturado por el catch en el componente login
  }
}

// async function login(nro_documento, cod_seguridad, captchaToken) {
//   try {
//     setCargandoUsuario(true);
//     setError(null); // Limpiamos errores previos

//     const { data } = await Axios.post('/api/usuarios/login/secure', {
//       nro_documento,
//       cod_seguridad,
//       captchaToken
//     });

//     setUsuario(data.usuario);
//     obtenerObrero(data.usuario.id_obrero);
//     setearUsuario(data.usuario);
//     setToken(data.token);
//     setCargandoUsuario(false);

//   } catch (err) {
//     setCargandoUsuario(false);

//     // Verificamos que la respuesta de la API exista
//     if (err.response && err.response.data) {
//       const { code, message } = err.response.data;

//       switch (code) {
//         case 'INVALID_CREDENTIALS':
//           setError('Los datos ingresados no son correctos. Verificá tu DNI y código.');
//           break;
//         case 'RATE_LIMIT_EXCEEDED':
//           setError('Demasiados intentos. Por favor, esperá unos minutos.');
//           break;
//         case 'CAPTCHA_INVALIDO':
//           setError('La validación de seguridad falló. Intentá nuevamente.');
//           break;
//         default:
//           setError(message || 'Error al intentar ingresar.');
//       }
//     } else {
//       setError('No es posible conectar con el servidor.');
//     }
//   }
// }

// async function login(nro_documento,cod_seguridad,captchaToken){

//   try{
//     setCargandoUsuario(true);
//     const { data } = await Axios.post( // le digo que espere a que Axios se ejecute
//       '/api/usuarios/login/secure',{nro_documento,cod_seguridad,captchaToken});
//       setUsuario(data.usuario);
//       obtenerObrero(data.usuario.id_obrero);
//       setearUsuario(data.usuario); // para exponerlo en el context
//       setToken(data.token)
//       setError(null)  
//       setCargandoUsuario(false);
//   }catch(err){
//       setCargandoUsuario(false);

//       if(err.response.status){

//         alert(JSON.stringify(err.response.data.code))
//       //   switch (err.response.data.code) {
//       //   case 'INVALID_CREDENTIALS':
//       //   case 'INVALID_SECURITY_CODE':
//       //     mostrar "datos incorrectos"
//       //     break;

//       //   case 'INVALID_CAPTCHA':
//       //     mostrar "validación de seguridad falló"
//       //     break;

//       //   case 'RATE_LIMITED':
//       //     mostrar "esperá unos minutos"
//       //     break;
//       // }

//           // if(err.response.status==404){
//           //     setError(`Los datos ingresados no son correctos.\n\nPor favor, verificá la información e intentá nuevamente`)
//           //   }else if (err.response.status==400){
//           //     setError(`Los datos ingresados no son correctos.\n\nPor favor, verificá la información e intentá nuevamente`)
//           // }else if (err.response.status==500){
//           //     setError('No es posible ingresar en este momento. Por favor contacte a la oficina UAD')
//           // }else{
//           //   setError('No es posible ingresar en este momento. Por favor contacte a la oficina UAD')
//           // }
//       }else{
//         setError('No es posible ingresar en este momento. Por favor contacte a la oficina UAD')
//       }

//   }
 
// }

// async function login(nro_documento,cod_seguridad,cambiarPassword){

//   try{
//     setCargandoUsuario(true);
//     const { data } = await Axios.post( // le digo que espere a que Axios se ejecute
//       '/api/usuarios/login',{nro_documento,cod_seguridad});
//       setUsuario(data.usuario);
//       obtenerObrero(data.usuario.id_obrero);
//       setearUsuario(data.usuario); // para exponerlo en el context
//       setToken(data.token)
//       setError(null)  
//       setCargandoUsuario(false);
//   }catch(err){
//       setCargandoUsuario(false);

//       if(err.response.status){
//           if(err.response.status==404){
//               setError(`Los datos ingresados no son correctos.\n\nPor favor, verificá la información e intentá nuevamente`)
//             }else if (err.response.status==400){
//               setError(`Los datos ingresados no son correctos.\n\nPor favor, verificá la información e intentá nuevamente`)
//           }else if (err.response.status==500){
//               setError('No es posible ingresar en este momento. Por favor contacte a la oficina UAD')
//           }else{
//             setError('No es posible ingresar en este momento. Por favor contacte a la oficina UAD')
//           }
//       }else{
//         setError('No es posible ingresar en este momento. Por favor contacte a la oficina UAD')
//       }

//   }
 
// }

function obtenerAsociacion(infoObrero,usuario) {
  if (usuario.id_iglesia_dependiente){
      if (usuario.id_iglesia_dependiente > 0){ // depende de una iglesia si el id es positivo
          if (infoObrero.sexo=='M'){
            return `Asociado a la iglesia ${usuario.dependiente}`
          }else{
              return `Asociada a la iglesia ${usuario.dependiente}`
          }
      }else{  // depende de un ministerio si el id es negativo
          if (infoObrero.sexo=='M'){
              return `Asociado al ministerio de ${usuario.dependiente}`
          }else{
              return `Asociada al ministerio de ${usuario.dependiente}`
          }
      }
  } else{
      return ''
  }
}


  if (cargandoUsuario){
    return (
      <Main center alinear>
          <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
              <Spinner className="h-12 w-12" />
              <span className="cargando font-semibold text-[15px]">Cargando perfil...</span>
          </div>
      </Main>
    )
  };

  return (
    <BrowserRouter>
    <div className="Main center" onMouseUp={monitorearClicks}>
       {
         usuario ? 
         <div className='w-full flex flex-col'>
          <div className='flex flex-col lg:flex-row'>
            <div className='w-full flex lg:hidden'>
              <MenuAppBar usuario={usuario} logout={logout} />
            </div>
            
            <MenuSidebar usuario={usuario} logout={logout} />
            <div className='w-full flex flex-row min-h-[calc(100vh)]'>
              <MenuDrawer />
              <Main>
                <div className='w-full hidden lg:flex'>
                  <MenuAppBar usuario={usuario} logout={logout} className="w-full"/>
                </div>
                {usuario.id_iglesia_dependiente && <Alert className="!hidden" variant="outlined" severity="info">
                    {obtenerAsociacion(infoObrero,usuario)}
                </Alert>}
                {mostrarExtras() && <p>{JSON.stringify(usuario)}</p>}
                  <LoginRoutes mostrarError={mostrarError} ocultarCredencial={ocultarCredencial} usuario={usuario}/>
              </Main>
            </div>
          </div>
          <Footer />
         </div>
          :
          <Main center>
              <LogoutRoutes login={login} mostrarError={mostrarError} error={error} isIOSWebView={isIOSWebView}/>
          </Main>
       } 

     </div>
    </BrowserRouter>
  );
}

// export default App;
// envuelvo a la aplicación con un proveedor de contexto para que la usen los componentes
// hijos.
export default ()=> 
<ApolloProvider client={client_graphql}>
  <AlumnoProvider>  
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={() => <h1>I believe something went wrong</h1>}>
      <CustomSnackBar/>
      <ThemeProvider>
        <App></App>
      </ThemeProvider>
    </ErrorBoundary>
  </AlumnoProvider>
</ApolloProvider>

/*
function LoginRoutesOLD({logout,ocultarCredencial,usuario}){
  return (
    <Switch>
<Route default exact path="/home" render={props => (<Home {...props}/>)}/>  
<Route exact path="/credencial" render={props => (<ContenedorVistas {...props} usuario={usuario} tipo="credencial"/>)}/>  
<Route exact path="/logs" render={props => (<ContenedorVistas {...props} usuario={usuario} tipo="logs"/>)}/>  
<Route exact path="/qr" render={props => (<ContenedorVistas {...props} usuario={usuario} tipo="qr"/>)}/>  
<Route exact path="/info" render={props => (<ContenedorVistas {...props} usuario={usuario} tipo="obrero"/> )}/>   
<Route exact path="/iglesia/:id_iglesia" render={props => (<ContenedorVistas {...props} usuario={usuario} tipo="iglesia"/> )}/>   
<Route exact path="/listado/:vista" render={props => (<ContenedorVistas {...props} usuario={usuario} tipo="listadoigl"/> )}/>   
<Route exact path="/nomina" render={props => (<ContenedorVistas {...props} usuario={usuario} tipo="nomina"/> )}/>   
<Route exact path="/documentos" render={props => (<ContenedorVistas {...props} usuario={usuario} tipo="documentos"/> )}/>   
<Route exact path="/password" render={props => (<ContenedorVistas {...props} usuario={usuario} tipo="password"/> )}/>   
<Route exact path="/compromiso" render={props => (<ContenedorVistas {...props} usuario={usuario} tipo="compromiso"/> )}/>   
<Route path='/externo/gestiones' element={<Tramites usuario={usuario}/>} />  

  </Switch>
  )
}
*/
/*
function LogoutRoutes({login, mostrarError, error}){
  return (
    <Switch>
        <Route  exact path="/" 
                render={props =><Login {...props} 
                login={login} mostrarError={mostrarError} error={error}/>} default/>
        <Route  path="/login" 
                render={props =><Login {...props} 
                login={login} mostrarError={mostrarError} error={error}/>} default/>                
  </Switch>
  )
}
*/

const LoginRoutes = ({logout,ocultarCredencial,usuario})=>{
  return <Routes>
    <Route default path='/' element={<Home/>}  />  
    {/* Cuando no puede resolver una ruta que vaya a / para que reemplace la ruta no resuelta */}
    <Route default path='*' element={<Navigate to='/' replace={true} />}  />  
    <Route path='/home' element={<Home/>}  />  
    <Route path='/logs' element={<ContenedorVistas usuario={usuario} tipo="logs"/>}  />  
    <Route path='/credencial' element={<ContenedorVistas usuario={usuario} tipo="credencial"/>}  />  
    <Route path='/qr' element={<ContenedorVistas usuario={usuario} tipo="qr"/>}  />  
    <Route exact path='/info' element={<ContenedorVistas usuario={usuario} tipo="obrero"/>}  />
    <Route path='/iglesia/:id_iglesia' element={<ContenedorVistas usuario={usuario} tipo="iglesia"/>}  />  
    <Route path='/listado/:vista' element={<ContenedorVistas usuario={usuario} tipo="listadoigl"/>}  />  
    <Route path='/nomina' element={<ContenedorVistas  usuario={usuario} tipo="nomina"/>}  />  
    <Route path='/delegados' element={<ContenedorVistas  usuario={usuario} tipo="delegados"/>}  />  
    <Route path='/documentos' element={<ContenedorVistas  usuario={usuario} tipo="documentos"/>}  />  
    <Route path='/password' element={<ContenedorVistas usuario={usuario} tipo="password"/>} />  
    <Route path='/compromiso' element={<ContenedorVistas usuario={usuario} tipo="compromiso"/>}  />  
    <Route path='/tramites' element={<Tramites/>}  />  
    <Route path='/doctrina' element={<Doctrina/>}  />  
    <Route path='/estatutos' element={<Estatutos/>}  />  
  </Routes>
}

// const LogoutRoutes = ({login, mostrarError, error})=>{
//   return <Routes>
//          <Route path='/externos/temporal/:id_tramite' element={<Temporal login={login} mostrarError={mostrarError} error={error}/>}  />  
//          <Route default path='/' element={<Login login={login} mostrarError={mostrarError} error={error}/>}  />  
//          <Route path='/login/inicial/:id_tramite' element={<Login login={login} mostrarError={mostrarError} error={error}/>}  />  
//          {/* Cuando no puede resolver una ruta que vaya a / para que reemplace la ruta no resuelta */}
//          <Route default path='*' element={<Navigate to='/' replace={true} />}  />  
//          <Route default path='/login' element={<Login login={login} mostrarError={mostrarError} error={error}/>}  />  
//   </Routes>
// }


const LogoutRoutes = ({ login, mostrarError, error,isIOSWebView }) => {
  // Centralizamos las props para no repetirlas 5 veces
  const authProps = { login, mostrarError, error,isIOSWebView };

  return (
    <Routes>
      {/* Ruta específica para trámites temporales */}
      <Route 
        path="/externos/temporal/:id_tramite" 
        element={<Temporal {...authProps} />} 
      />

      {/* Agrupamos las variantes de Login */}
      {["/", "/login", "/login/inicial/:id_tramite"].map((path) => (
        <Route 
          key={path}
          path={path} 
          element={<Login {...authProps} />} 
        />
      ))}

      {/* Catch-all: Si nada coincide, al home (Login) */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function monitorearClicks(){ // la función monitorearClicks se dispara cada vez que el usuario hace click y guarda la fecha hora minuto y segundo para que se pueda calcular el tiempo de inactividad
    sessionStorage.setItem('haction',fechaMouse()) // la hora de ultimo click se guarda en memoria y se consulta cada X segundos para comparar y calcular los tiempos
   // clearTimeout(id_tiempo_reinicio)
}

function fechaMouse(){
    return `${fechaActual()}` // cada vez que el usuario hace click se guarda la fecha hora minuto y segundo 
                              // la función fechaActual esta en un archivo Helpers/fechas.js y usa moment.js para crear la fecha
}

function verificarTiempo(setReinicioLogin){  //esta función se ejecuta cada x segundos con un setInterval para verificar la diferencia entre la hora actual y la última hora de actividad
    const ultimoRegistro = sessionStorage.getItem('haction') // en 'haction' se va guardando la hora en que el usuario hace un click en cualquier lado como evidencia de actividad
    const checking = sessionStorage.getItem('checking') // 'checking' se usa como flag para saber si ya se mostró el mensaje preguntando al usuario si sigue conectado
    let diferencia = 0; // la variable diferencia la usamos para calcular el tiempo que pasó entre la última hora de actividad y la hora actual 
    let numero_al_azar = Math.floor(Math.random() * 100); // numero_al_azar lo usamos para forzar el renderizado de la vista, para ello modificamos esa propiedad del estado cambiando su valor al azar (si fuera igual no se renderizaría porque no detecta un cambio en el estado)

    if (!ultimoRegistro){ // si no hay un registro de la hora de actividad significa que es la primera vez que se monta esta vista entonces inicializamos la hora actual y luego seguimos monitoreando los clicks
        sessionStorage.setItem('haction',fechaActual())
    }else{
      diferencia = compararFechas(ultimoRegistro) // comparamos la hora actual con la última hora registrada de actividad del usuario


      if (diferencia>tiempo_en_segundos_inactividad && !checking ){ // si la diferencia de tiempo es de 3 minutos y aún no hemos mostrado el mensaje al usuario iniciamos el procedimiento para mostrar el mensaje pidiendo al usuario que confirme que sigue conectado y activando los timers de reinicio
       contador = 100; // es la variable que usamos para mostrar al usurio el tiempo que falta para que termine su sesión por inactividad 

       //sessionStorage.removeItem('haction')
       sessionStorage.setItem('checking',true) // marcamos el flag para evitar que se vuelva a hacer todo N veces o sea para asegurarnos que se haga 1 sola vez cada vez que se detecta la inactividad
       
       setTimeout(() => {
          mostrarTimer() // iniciamos el contador de fin de sesión, pero en 500 milisegundos para asegurarnos que el elemento con id "mensaje_fin_sesion" ya exista en el DOM, necesitamos esperar un poco porque todavía no existe, se crea en el html del sweat alert
       }, 500);

        id_tiempo_reinicio = setTimeout(() => { // una vez que detectamos la inactividad de N minutos y mostramos el mensaje al usuario activamos un timer de 100 segundos, es decir en 100 segundo se va a ejecutar el fin de la sesión si no confirma que sigue conectado 
            
            // si el usurio no confirmo que sigue conectado eliminamos el token que le permitía acceder a los recursos del servidor
            // forzamos el renderizado de la vista al cambiar el estado modificando la propiedad reinicioLogin con la funcion setRenicioLogin
            // también eliminamos el flag para que no persista y se pueda volver a iniciar el ciclo de monitoreo
            // limpiamos el intervalo que hacia de timer
            sessionStorage.removeItem('REG_TOKEN')
            sessionStorage.removeItem('checking')
            clearInterval(id_intervalo_contador)
            clearInterval(id_intervalo_monitoreo)
            setReinicioLogin()
          }, 100000);

        // Mostramos la ventana al usuario para que confirme si sigue conectado
        // es importante que haya en el html del mensaje el elemento con id mensaje_fin_sesion para que se muestre el timer con el contador de fin de sesión
        Swal.fire({
          html:'<h3>¿Sigues conectado?</h3><p id="mensaje_fin_sesion"></p>',
          confirmButtonText:'Si, sigo conectado',
          allowOutsideClick: false
      }).then(
          resultado=>{
              if (resultado.value){

                 // si el usuario confirma que sigue conectado limpiamos los flags para reiniciar el monitoreo hasta detectar otro tiempo de inactividad y volver a disparar el proceso de confirmación
                 sessionStorage.removeItem('haction') // lo limpio para reiniciar la hora de última actividad y comenzar de nuevo desde la hora actual
                 sessionStorage.removeItem('checking') // lo limpio para que no persista y se pueda volver a disparar el proceso de confirmación de actividad, si no se limpiara no entraría otra vez
                 clearInterval(id_intervalo_contador) // lo limpio para que deje de contar hacia atrás
                 clearTimeout(id_tiempo_reinicio) // lo limpio para detener el proceso de finalización de la sesión
              }
          }
      )
      }
    }
} 

function mostrarTimer(){
    let texto = document.getElementById("mensaje_fin_sesion")

    // busco en el DOM el elemento con id mensaje_fin_sesion que se creó en el html del mensaje con sweatalert
    // y luego cada 1 segundo resto 1 del contador hasta el fin de la sesión

    id_intervalo_contador = setInterval(() => {
        contador = contador - 1;
        texto.innerHTML= `La sesión terminará en  ${contador}`
    }, 1000);
}

function confirmarTiempoInactividadAceptado(){
// uso esta funcion para modificar el tiempo de inactividad (en segundos) que se tomamos como
// parametro para pedir la confirmación al usuario que sigue conectado. Por default es 180 segundos pero
// en testing lo puedo llegar a modificar para algún tipo de prueba
// Si en la clave tcustom del localstorage hay un número lo va a tomar para reemplazar la variable tiempo_en_segundos_inactividad
// si no existe o no es un número toma el que ya estaba asignado en la declaración de la variable

    const existe_tcustom = localStorage.getItem('tcustom')
    if (existe_tcustom  ){

        const prueba_numero = Number(existe_tcustom)
        
        console.log('typeof(prueba_numero)',typeof(prueba_numero))

        if (typeof(prueba_numero)==='number'){
            tiempo_en_segundos_inactividad = prueba_numero;
        }
    }
}

function ErrorFallback({error, resetErrorBoundary}) {
  try{
    const {data} = Axios.get(`/api/tablasgenerales/error/${error}/22`)
}catch(err){
    console.log(err)
}

  return (
    <Main center>
      <div className="text-center">
          <h1>error 2</h1>
          <p>{error}</p>
      </div>
    </Main>
  )
}

const mostrarExtras = ()=>{
  const textras =localStorage.getItem('textras');

  if(textras){
      return true
  }

  return false
}